<template>
  <div class="row">
    <router-view name="left" class="left" v-if="!mobile"></router-view>
    <router-view name="right" class="right"></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobile: false,
    };
  },
  mounted() {
    this.mobile = this.$piggyBank.mobile;
    this.$root.$on("mobile", (mobile) => (this.mobile = mobile));
  },
};
</script>

<style lang="scss" scoped>
.row {
  height: 100%;
  // display: flex;
  // overflow-y: hidden;
}
</style>